// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 25","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 17.5693C18.9998 19.0389 17.9855 20.1852 16.7461 20.9082C15.4821 21.6454 13.8018 22.0693 12 22.0693C10.1982 22.0693 8.5179 21.6454 7.25391 20.9082C6.01454 20.1852 5.00022 19.0389 5 17.5693V13.9053L12 18.4551L19 13.9053V17.5693Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.835 8.56934L22 9.7627V16.0693H20V11.0625L12 16.2627L0.165039 8.56934L1.77832 7.51953C2.77627 8.91151 4.40658 9.81934 6.25 9.81934C9.28757 9.81934 11.75 7.3569 11.75 4.31934C11.75 3.30195 11.4728 2.34966 10.9912 1.53223L12 0.876953L23.835 8.56934Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.53223 3.03613L10.5693 4.31934L7.53223 5.60156L6.25 8.63867L4.9668 5.60156L1.93066 4.31934L4.9668 3.03613L6.25 0L7.53223 3.03613Z"}}]};

const AiEducationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'ai-education-filled',
    ref,
    icon: element,
  },
));

AiEducationFilledIcon.displayName = 'AiEducationFilledIcon';

export default AiEducationFilledIcon;
